export enum PageNumber {
    User = 13,
    MyProfile = 13.1,
    ProfileAndSettings = 13.2,
    Logout = 0,
    Dashboard = 0,
    Brands = 1,
    ViewBrand = 1.2,
    Users = 2,
    EndUsers = 2.1,
    ViewEndUser = 2.7,
    ViewUserInteractionsStatistics = 2.8,
    ViewUserMatchScores = 2.7,
    Introductions = 2.9,
    ViewIntroduction = 2.11,
    Groups = 2.2,
    SystemUsers = 2.3,
    ViewSystemUser = 2.6,
    Roles = 2.5,
    ViewRolePermissions = 2.4,
    TagRules = 2.12,
    Content = 3,
    AppContent = 3.1,
    Communications = 3.2,
    ViewCommunication = 3.2,
    TranslationsList = 3.3,
    InfoScreens = 3.4,
    ViewInfoScreen = 3.6,
    Positions = 3.5,
    LangTranslations = 3.7,
    Questionnaires = 4,
    ViewQuestionnaire = 4.4,
    ViewQuestionFromQuestionnaire = 4.1,
    QuestionnaireList = 4.2,
    QuestionsList = 4.3,
    ViewQuestion = 4.1,
    AttributesList = 4.5,
    ViewAttribute = 4.5,
    Predictors = 4.6,
    AutoCompleteAnswers = 4.7,
    Lora = 5,
    ScreenFlowMgmt = 5.1,
    ContentOrder = 5.2,
    SettingsAlgorithm = 5.3,
    AISimulations = 5.4,
    SupportCenter = 6,
    CustomerSupportTickets = 6.1,
    SystemTickets = 6.1,
    CustomerSupportSettings = 6.2,
    CustomerSupportTicketView = 6.3,
    SMEMarketplace = 7,
    ShidduchRequests = 7.1,
    ShidduchRequestView = 7.2,
    ShidduchDeclines = 7.3,
    SMEProfiles = 7.4,
    ViewSMEProfile = 7.5,

    ContentCenter = 8,
    ContentCenterList = 8.1,
    ViewContent = 8.2, 

    Settings = 9,
    General = 9.1,
    System = 9.13,
    WhiteLabeling = 9.2,
    Notifications = 9.3,
    Localization = 9.4,
    Triggers = 9.5,
    Mobile = 9.6,
    WebManagement = 9.7,
    DBCopy = 9.8,
    AdminTask = 9.9,
    ViewLogs = 9.11,
    LinkToOldBackOffice = 9.12,

    Reports = 10,
    UsersReport = 10.1,
    QuestionsReport = 10.1,
    ChatsReport = 10.1,
    CommunicationsReport = 10.1,
    InteractionsReport = 10.1,
    CustomerSupportReport = 10.1,
    DevicesReport = 10.1,
    
    Marketing = 11,
    Empty2 = 11.1,

    PremiumSettings = 12,
    TopLevel = 12.1,
    BrandLevel = 12.2
  }
  